import React, { createContext, useState, useContext } from "react";

const SelectIndicationContext = createContext();

export const useSelectIndicationContext = () => {
  const context = useContext(SelectIndicationContext);
  if (!context) {
    throw new Error(`SelectIndicationContext provider is not found`);
  }
  return context;
};

export const SelectIndicationContextProvider = ({ children }) => {
  const [selectIndication, setSelectIndication] = useState("");

  return (
    <SelectIndicationContext.Provider
      value={{
        selectIndication,
        setSelectIndication,
      }}
    >
      {children}
    </SelectIndicationContext.Provider>
  );
};

export default SelectIndicationContext;
